export default "__VITE_ASSET__520df82e__"